import { InlineTooltip } from '~/components';
import React from 'react';

export default function TimesheetSubmittedTooltip() {
  return <InlineTooltip message="Timesheet has been submitted." />;
}
